import { Box } from '@material-ui/core'
import { Skeleton as MuiSkeleton } from '@material-ui/lab'

export function LoadingConfirmStep() {
  return (
    <Box
      role='progressbar'
      style={{
        height: '32rem',
      }}
    >
      <MuiSkeleton
        animation='wave'
        width='100%'
        height='100%'
        variant='text'
        style={{ transform: 'initial' }}
      />
    </Box>
  )
}
